import { BrowsePageSearchParams } from 'app/(pages)/browse/models'

export type DateValues = {
  startDate?: Date
  pickupAt?: string
  endDate?: Date
  returnAt?: string
}

export const parseBrowsePageSearchParamsDates = (searchParams: BrowsePageSearchParams | undefined): DateValues => {
  if (!searchParams || !searchParams.rentedFrom || !searchParams.rentedTo) {
    return {}
  }

  const rentedFromParts = searchParams.rentedFrom.split('T')
  const rentedToParts = searchParams.rentedTo.split('T')

  const startDate = new Date(rentedFromParts[0])
  const pickupAt = rentedFromParts[1].split(':')[0]

  const endDate = new Date(rentedToParts[0])
  const returnAt = rentedToParts[1].split(':')[0]

  return {
    startDate,
    pickupAt,
    endDate,
    returnAt,
  }
}
